import { createReduxEnhancer } from '@sentry/react';

import { AppState } from 'lib/types/global';

/**
 * Transform the app's state object before sending it to Sentry.
 */
const stateTransformer = (
  state: AppState,
): Omit<AppState, 'request'> & { request: undefined } => ({
  ...state,

  // contains session cookie token which
  // could be tied back to an individual
  request: undefined,

  // remove personal information
  session: {
    ...state.session,
    user: undefined,
  },
});

const sentryMiddleware = createReduxEnhancer({
  configureScopeWithState: (scope, state: AppState) => {
    if (state.session.user) {
      scope.setUser({
        id: state.session.user.drnId,
        email: state.session.user.email,
      });
    }
  },
  stateTransformer,
});

export default sentryMiddleware;
